import CustomCard from "../../../../components/CustomCard";
import {Avatar} from "@mui/material";
import IconPersonDefault from "../../../../assets/ImagesDefaults/ic-person-v2.svg";
import CustomChip from "../../../../components/CustomChip";
import {colors} from "../../../../enums/colors";
import {AccessDevicesTitle, IconClockTable} from "../../../../components/buttons/IconButtons";
import CustomTooltip from "../../../../components/CustomTooltip";
import {getTimeFormat} from "../../../../Apis/functions";
import ServicesAccessMethod from "./ServicesAccessMethod";
/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    FullStack Developer
 * @Email       kpozos@ibl.mx
 */
const DailyServicesCompactRow = ({ row, t }) => {

    return <>
        <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 py-1 py-lg-0'>
            <div className={"d-flex align-items-center gap-12px"}>
                <CustomCard classCard={'card-border-8px '} classContent={'p-0 background-primary-25'}>
                    {row.image ? (
                        <img
                            src={`data:image/jpeg;base64,${row.image}`}
                            alt="avatar"
                            className="w-40px object-fit-cover"
                        />
                    ) : (
                        <Avatar src={IconPersonDefault} className='me-12px p-1' />
                    )}
                </CustomCard>
                <div className={'flex-grow-0 minw-0'}>
                    <CustomTooltip
                        text={row.fullName}
                        classes={'fs-16px ibl-font-w-600 text-capitalize text-ellipsis-1-row'}
                        showIfTruncated={true}
                        placement={'top'}
                    />
                </div>

                <div className='vertical-separator-shades-950 h-36px' />

                <CustomChip
                    legend={`ID No ${row.employeeId}`}
                    background={colors.secondary100}
                    fontColor={colors.secondary700}
                    borderColor={colors.secondary150}
                />
            </div>
        </div>
        <div className='col-sm-12 col-md-6 col-lg-3 col-xl-3 col-xxl-3 py-1 py-lg-0'>
            <div className={"d-flex justify-content-start justify-content-lg-end align-items-center gap-46px"}>
                <div>
                    <div className={"d-flex align-items-center"}>
                        <div>
                            <IconClockTable className={'mr-8px mb-1'} />
                        </div>
                        <div className={'flex-grow-1 minw-0'}>
                            <CustomTooltip
                                text={t('time')}
                                classes={'fs-14px ibl-font-w-600 text-ellipsis-1-row'}
                                showIfTruncated={true}
                                placement={'top'}
                            />
                        </div>
                    </div>
                    <div className={"d-flex align-items-center"}>
                        <div className={'flex-grow-1 minw-0'}>
                            <CustomTooltip
                                text={getTimeFormat(row.entryDate)}
                                classes={'font-color-shades-500 fs-14px text-ellipsis-1-row'}
                                showIfTruncated={true}
                                placement={'top'}
                            />
                        </div>
                    </div>
                </div>

                <div>
                    <div className={"d-flex align-items-center"}>
                        <div>
                            <AccessDevicesTitle className={'mr-8px mb-1'} />
                        </div>
                        <div className={'flex-grow-1 minw-0'}>
                            <CustomTooltip
                                text={t('device')}
                                classes={'fs-14px ibl-font-w-600 text-ellipsis-1-row'}
                                showIfTruncated={true}
                                placement={'top'}
                            />
                        </div>
                    </div>
                    <div className={"d-flex align-items-center"}>
                        <div className={'flex-grow-1 minw-0'}>
                            <CustomTooltip
                                text={row.entryDeviceName}
                                classes={'font-color-shades-500 fs-14px text-ellipsis-1-row'}
                                showIfTruncated={true}
                                placement={'top'}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className='col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3 py-1 py-lg-0'>
            <ServicesAccessMethod row={row} t={t}/>
        </div>
    </>
};

export default DailyServicesCompactRow;
